import React, { useState, useEffect } from "react";
import { getCustomerTypes, getSuppliers, createLocation } from "../../services";
import MultiSelect from "react-multi-select-component";

const LocationCreate = (props) => {

  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [customerTypeArray, setCustomerTypeArray] = useState();
  const [supplierArray, setSupplierArray] = useState();
  const [customerType, setCustomerType] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [username, setUsername] = useState();

  useEffect(() => {
    getCustomerTypes().then((types) => {
      // Get all customer types and create a options list to use in the selectbox
      const typeOptions = types.customer_types.map((type) => ({
        label: type.name,
        value: type.id,
      }));
      setCustomerTypeArray(typeOptions);
    });

    getSuppliers().then((types) => {
      // Get all suppliers and create a options list to use in the selectbox
      const typeOptions = types.suppliers.map((type) => ({
        label: type.name,
        value: type.id,
      }));
      setSupplierArray(typeOptions);
    });
  }, []);

  const submitLocation = () => {
    createLocation(
      props.customerId,
      name,
      supplier,
      customerType,
      username,
      address,
      postal,
      phone,
      email,
      city,
      firstName + ' ' + lastName
      ).then(
      (res) => {
        props.setLocationId(res.location_id);
        props.next();
      }
    );
  };

  const newLocation = () => {
    createLocation(
      props.customerId,
      name,
      supplier,
      customerType,
      username,
      address,
      postal,
      phone,
      email,
      city,
      firstName + ' ' + lastName
      ).then(
      (res) => {
        props.setLocationId(res.location_id);
        setCustomerType("");
        setName("");
        setPhone("");
        setEmail("");
        setAddress("");
        setCity("");
        setPostal("");
        setFirstName("");
        setLastName("");
        setUsername("");
        setSupplier("");
      }
    );
    console.log(customerType);
  };

  return (
    <div className="form__container__content">
      <div className="form__container__content__category">
        <span>Locatiegegevens</span>
      </div>
      <div className="form__fields">
        <div className="form__fields__field">
          <span className="form__fields__field__label">Locatienaam</span>
          <input
            // required="true"
            onChange={(e) => setName(e.target.value)}
            type="text"
            value={name}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Adres</span>
          <input
            // required="true"
            onChange={(e) => setAddress(e.target.value)}
            type="text"
            value={address}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Postcode</span>
          <input
            // required="true"
            onChange={(e) => setPostal(e.target.value)}
            type="text"
            value={postal}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Plaats</span>
          <input
            // required="true"
            onChange={(e) => setCity(e.target.value)}
            type="text"
            value={city}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Voornaam contactpersoon</span>
          <input
            // required="true"
            onChange={(e) => setFirstName(e.target.value)}
            type="text"
            value={firstName}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Achternaam contactpersoon</span>
          <input
            // required="true"
            onChange={(e) => setLastName(e.target.value)}
            type="text"
            value={lastName}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">E-mailadres</span>
          <input
            // required="true"
            onChange={(e) => setEmail(e.target.value)}
            type="text"
            value={email}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Telefoonnummer</span>
          <input
            // required="true"
            onChange={(e) => setPhone(e.target.value)}
            type="text"
            value={phone}
            className="form__fields__field__input"
          />
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Klanttypering</span>
          {customerTypeArray && (
            <MultiSelect
              overrideStrings={{
                selectSomeItems: "Selecteren...",
                allItemsAreSelected: "Alles is geselecteerd",
                selectAll: "Selecteer alles",
                search: "Zoeken",
                clearSearch: "Wis zoekopdracht",
              }}
              options={customerTypeArray}
              value={customerType}
              onChange={setCustomerType}
              labelledBy={"Select"}
            />
          )}
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Leverancier</span>
          {supplierArray && (
            <MultiSelect
              overrideStrings={{
                selectSomeItems: "Selecteren...",
                allItemsAreSelected: "Alles is geselecteerd",
                selectAll: "Selecteer alles",
                search: "Zoeken",
                clearSearch: "Wis zoekopdracht",
              }}
              options={supplierArray}
              value={supplier}
              onChange={setSupplier}
              labelledBy={"Select"}
            />
          )}
        </div>
        <div className="form__fields__field">
          <span className="form__fields__field__label">Gebruikersnaam voor locatiemedewerkers</span>
          <input
            onChange={(e) => setUsername(e.target.value.replace(' ', '_'))}
            type="text"
            value={username}
            className="form__fields__field__input"
          />
        </div>
      </div>
      <button
        className="form__container__content__button"
        onClick={() => submitLocation()}
      >
        OPSLAAN <i className="fas fa-arrow-right"></i>
      </button>
      <button
        className="form__container__content__button btn-success"
        onClick={() => newLocation()}
      >
        Nog een locatie <i className="fas fa-plus"></i>
      </button>
    </div>
  );
};

export default LocationCreate;
